import {RiskProfileInput, RiskType} from '../../schema-types/globalTypes';
import {UpsertRiskProfileVariables} from '../../schema-types/UpsertRiskProfile';

import {riskFormType} from './riskFields';

export const riskFormToVariables = (
  contactIds: string[],
  values: riskFormType,
  reviewId: string
) => {
  const variables: UpsertRiskProfileVariables = {
    inputs: [],
  };
  for (const contactId of contactIds) {
    const profile: RiskProfileInput = {
      reviewId,
      contactId,
      centralPropositionAgreed: values.centralPropositionAgreed || false,
      dfmAgreed: values.dfmAgreed || false,
      noChangeReasonNotes: values.noChangeReasonNotes,
      outcomeRiskScore: values.outcomeRisk[contactId]?.score,
      outcomeRiskNotes: values.outcomeRisk[contactId]?.notes,
      riskToleranceQuestionnaireDeclineReason: values.outcomeRisk[contactId]
        ?.isRiskToleranceQuestionnaireDeclined
        ? values.outcomeRisk[contactId]?.riskToleranceQuestionnaireDeclineReason?.trim()
        : undefined,
      hasNoRiskDicussion: values.hasNoRiskDicussion,
      isRiskToleranceQuestionnaireDeclined:
        values.outcomeRisk[contactId]?.isRiskToleranceQuestionnaireDeclined,
    };
    variables.inputs.push(profile);
  }
  return variables;
};

// The three consolidated categories introduced by ON-9175 are deliberately
// omitted here: this array drives the existing 7-section UI, which ON-9177
// will replace. `as const` narrows the element type to the union of these
// seven enum members, keeping the indexers into `riskFormType` (which only
// declares the seven legacy keys) type-checking after the new RiskType
// values were added to the enum.
export const riskSegmentsOrderedByBusinessLogic = [
  RiskType.RISK_TOLERANCE,
  RiskType.RISK_CAPACITY,
  RiskType.TIMEFRAMES,
  RiskType.KNOWLEDGE_AND_EXPERIENCE,
  RiskType.CAPACITY_FOR_LOSS,
  RiskType.BEHAVIOURAL_CAPACITY,
  RiskType.VALUES,
] as const;
